module.exports = __webpack_public_path__ + "img/ventilador_success.35b3eb8c.svg";